import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import { INITPAGING } from "../based/Constants";
import GameServices from "./GameServices";

const TeamType = {
    HOME: "home",
    AWAY: "away",
};

function NHLGameMainPage(props) {
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [listModel, setListModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef(null);

    useEffect(() => {
        getData(paging);
    }, []);

    //lấy ds game
    const getData = async (page) => {
        setLoading(true);
        const [err, data] = await GameServices.GetGameClientByPage(page);
        if (!err && data && data.listObjects && data.listObjects.length > 0) {
            if (page.pageNumber == 1) setListModel(data.listObjects);
            else setListModel([...listModel, ...data.listObjects]);
            setPaging(data.paging);
            setHasMore(true);
        } else {
            if (page.pageNumber == 1) setListModel([]);
            setHasMore(false);
            setPaging(page);
        }

        setLoading(false);
    };

    const setLastCollectionHandler = (element) => {
        if (loading || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                let updatePaging = { ...paging };
                updatePaging.pageNumber += 1;
                getData(updatePaging);
            }
        });
        if (element) observer.current.observe(element);
    };

    const _getScoreByPeriod = (scores, period, type = TeamType.HOME) => {
        if (scores && scores.length > 0) {
            const scoreObj = scores.find((s) => s.period == period);
            if (scoreObj) {
                return type === "home" ? scoreObj.home : scoreObj.away;
            }
        }
        return "-";
    };

    const _getTotalScore = (scores, type = TeamType.HOME) => {
        if (scores && scores.length > 0) {
            let total = 0;
            scores.forEach((scoreObj) => {
                total += type === TeamType.HOME ? scoreObj.home : scoreObj.away;
            });
            return total;
        }
        return "-";
    };

    return (
        <Wrapper>
            <div className="lst_game">
                {listModel && listModel.length > 0 ? (
                    listModel.map((item, index) => {
                        return (
                            <div className={`game_item ${item.isCurrent ? "current" : ""}`} key={index} ref={setLastCollectionHandler}>
                                <div className="game_item-header">
                                    <div className="game_item-header-left">
                                        <div className="time">{/* <span>07:00</span> */}</div>
                                        <div className="date-time">
                                            <span>{Common.formatDate(new Date(item.gameDate), "timedate")}</span>
                                        </div>
                                    </div>
                                    <div className="game_item-header-right">
                                        {item.homeRate == 0 && item.awayRate == 0 && item.drawRate == 0 ? null : (
                                            <div className="game_rate">
                                                <div className="game_rate-left">
                                                    <span>
                                                        <sub>H</sub>
                                                        <main>{item.homeRate}</main>
                                                    </span>
                                                </div>
                                                <div className="game_rate-mid">
                                                    <span>
                                                        <sub>A</sub>
                                                        <main>{item.awayRate}</main>
                                                    </span>
                                                </div>
                                                <div className="game_rate-right">
                                                    <span>
                                                        <sub>D</sub>
                                                        <main>{item.drawRate}</main>
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        <div className="icon">
                                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 13L7 7L1 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="game_item_body">
                                    <div className="game_item_body-header">
                                        <div className="header-detail">{/* <span className="txt-orange">H2 - 25:23</span> */}</div>
                                        <div className="header-pts">
                                            <span>PTS</span>
                                        </div>
                                        <div className="header-dgp">
                                            <span>DGP</span>
                                        </div>
                                        <div className="header-percentage-true">
                                            <span>% TRUE</span>
                                        </div>
                                        <div className="header-h1">
                                            <span>H1</span>
                                        </div>
                                        <div className="header-h2">
                                            <span>H2</span>
                                        </div>
                                        <div className="header-h3">
                                            <span>H3</span>
                                        </div>
                                        <div className="header-t">
                                            <span>T</span>
                                        </div>
                                    </div>
                                    <div className="game_item_body-body">
                                        <div className="body_detail-item">
                                            <div className="logo_detail">
                                                <div className="icon">
                                                    <img src={item.homeLogo} alt="" />
                                                </div>
                                                <div className="name_detail">
                                                    <div className="name_detail-top">
                                                        <div className="team-abbr">
                                                            <span>{item.homeAbbrName}</span>
                                                        </div>
                                                        <div className="badge badge-succes">{item.homeRank}</div>
                                                        <div className="team_sub">
                                                            <span>{item.homeBoard}</span>
                                                        </div>
                                                    </div>
                                                    <div className="name_detail-bottom">
                                                        <span>{item.nhlHomeTeamName}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="pts-point">
                                                <span>{item.homePts}</span>
                                            </div>
                                            <div className="dgp-point">
                                                <span>{item.homeDeltaGoalPenalty}</span>
                                            </div>
                                            <div className="percentage-point">
                                                <span>{Math.round(item.homePercentageWin * 100)}%</span>
                                            </div>
                                            <div className="h1-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 1, TeamType.HOME)}</span>
                                            </div>
                                            <div className="h2-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 2, TeamType.HOME)}</span>
                                            </div>
                                            <div className="h3-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 3, TeamType.HOME)}</span>
                                            </div>
                                            <div className="t-point">
                                                <span>{_getTotalScore(item.gamePeriodScores, TeamType.HOME)}</span>
                                            </div>
                                        </div>
                                        <div className="body_detail-item">
                                            <div className="logo_detail">
                                                <div className="icon">
                                                    <img src={item.awayLogo} alt="" />
                                                </div>
                                                <div className="name_detail">
                                                    <div className="name_detail-top">
                                                        <div className="team-abbr">
                                                            <span>{item.awayAbbrName}</span>
                                                        </div>
                                                        <div className="badge badge-danger">{item.awayRank}</div>
                                                        <div className="team_sub">
                                                            <span>{item.awayBoard}</span>
                                                        </div>
                                                    </div>
                                                    <div className="name_detail-bottom">
                                                        <span>{item.nhlAwayTeamName}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="pts-point">
                                                <span>{item.awayPts}</span>
                                            </div>
                                            <div className="dgp-point">
                                                <span>{item.awayDeltaGoalPenalty}</span>
                                            </div>
                                            <div className="percentage-point">
                                                <span>{Math.round(item.awayPercentageWin * 100)}%</span>
                                            </div>
                                            <div className="h1-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 1, TeamType.AWAY)}</span>
                                            </div>
                                            <div className="h2-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 2, TeamType.AWAY)}</span>
                                            </div>
                                            <div className="h3-point">
                                                <span>{_getScoreByPeriod(item.gamePeriodScores, 3, TeamType.AWAY)}</span>
                                            </div>
                                            <div className="t-point">
                                                <span>{_getTotalScore(item.gamePeriodScores, TeamType.AWAY)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="game_item-bottom">
                                    {/* <div className="lst_delta-gas">
                                        <span className="delta-gas-item">0.3</span>
                                        <span className="delta-gas-item success">0.1</span>
                                        <span className="delta-gas-item danger">0.2</span>
                                    </div> */}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="no-data">
                        <span>No data available</span>
                    </div>
                )}
            </div>
        </Wrapper>
    );
}

export default NHLGameMainPage;

const Wrapper = styled.div`
    background: #8bbaed;
    font-family: "Roboto", sans-serif;

    .badge {
        padding: 2px 2px;
    }

    .icon img {
        width: 46px;
        height: 30px;
        object-fit: contain;
    }

    .logo_detail .icon {
        margin-right: 4px;
    }

    .name_detail-bottom {
        display: flex;
        margin-top: 2px;
    }

    .game_item-header {
        display: flex;
        align-items: center;
        padding: 8px;
    }

    .game_item {
        margin: 12px;
        border-radius: 8px;
        border: 1px solid #eaeaea;
        background: #fff;
    }

    .lst_game {
        display: flex;
        flex-direction: column;
    }

    .game_item-header-right {
        display: flex;
        align-items: center;
        margin-left: auto;
    }

    .game_item.current {
        background: #ffe8cf;
    }

    .game_rate {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.1);
        padding: 4px 8px;
    }

    .game_item-header-left {
        display: flex;
        align-items: center;
    }

    .game_item-header-left .time span {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .game_item-header-left .date-time span {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .date-time {
        margin-left: 12px;
    }

    .game_rate span {
        display: flex;
        align-items: baseline;
    }

    .game_rate span sub {
        color: #858585;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        bottom: 0 !important;
        margin-right: 4px;
    }

    .game_rate span main {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .game_rate-left {
        margin: 0 6px;
    }

    .game_rate-mid {
        margin: 0 6px;
    }

    .game_rate-right {
        margin: 0 6px;
    }

    .icon {
        display: flex;
    }

    .game_item-header-right .icon {
        margin-left: 6px;
    }

    .game_item_body-header {
        display: flex;
        align-items: center;
    }

    .body_detail-item {
        display: flex;
        align-items: center;
        margin: 4px 0;
    }

    .logo_detail {
        display: flex;
        align-items: center;
        width: 25%;
        overflow: hidden;
        flex: 1;
    }

    .header-detail {
        width: 25%;
        flex: 1;
    }

    .header-pts {
        width: 10%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-dgp {
        width: 10%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-percentage-true {
        width: 15%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-h1 {
        width: 7.5%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-h2 {
        width: 7.5%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-h3 {
        width: 7.5%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-t {
        width: 10%;
        display: flex;
        justify-content: center;
        color: #77888e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .header-detail span.txt-orange {
        color: #ff9100;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .game_item_body {
        padding: 4px 4px;
        border: 1px solid #eaeaea;
    }

    .name_detail-top {
        display: flex;
        align-items: center;
    }

    .pts-point {
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dgp-point {
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .percentage-point {
        width: 15%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .h1-point {
        width: 7.5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .h2-point {
        width: 7.5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .h3-point {
        width: 7.5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .t-point {
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .name_detail-bottom span {
        color: #77888e;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .name_detail-top .team-abbr span {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .name_detail-top .team_sub {
        color: #77888e;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .name_detail-top .badge {
        margin: 0 4px;
    }

    span.delta-gas-item {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 4px;
    }

    span.delta-gas-item.success {
        border-radius: 4px;
        background: #00d500;
        color: white;
        padding: 0 4px;
    }

    span.delta-gas-item.danger {
        border-radius: 4px;
        background: #c8102e;
        color: white;
        padding: 0 4px;
    }

    .lst_delta-gas {
        padding: 4px 0;
        overflow-x: auto;
    }

    .team-abbr {
        display: flex;
        align-items: center;
    }
`;
